import React from 'react'

import { mapPricingCategories } from 'helpers/dataTransformers/pricing'

import Amount from './components/Amount'
import Free from './components/Free'

import classes from './PricingDetails.module.scss'

/** @type {import("./types").default} */
const PricingDetails = ({ pricing, isColumn = false }) => {
  const hasPricing = Number(pricing?.amount) > 0

  const { hasFreeTrial } = mapPricingCategories(pricing?.categories)
  const showAmount = hasPricing

  return (
    <div className={classes.root}>
      {showAmount ? (
        <Amount pricing={pricing} className={isColumn ? classes.column : classes.row} />
      ) : (
        hasFreeTrial && <Free hasFreeTrial={hasFreeTrial} />
      )}
    </div>
  )
}

export default PricingDetails
